<h3 translate class="page-title text-center">TRANSLATIONS</h3>
<lib-filter-list #translationList [configService]="translationManagementListConfigService"></lib-filter-list>
